export const DEFAULT_ACTIVITY_CARD = {
  op: 'ui',
  name: 'ExpandableCard',
  summary: {
    op: 'ui',
    name: 'Stack',
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    spacing: 1,
    children: [{
      op: 'ui',
      name: 'Stack',
      maxWidth: '40%',
      children: [
        {
          op: 'ui',
          name: 'Typography',
          children: {
            op: 'ui',
            name: 'Stack',
            direction: 'row',
            gap: 1,
            alignItems: 'center',
            children: [
              {
                op: 'ui',
                name: 'Icon',
                fontSize: '1.25rem',
                icon: {
                  op: 'switch',
                  expr: {
                    op: 'context',
                    path: 'thingActivity.activityType',
                  },
                  options: {
                    geofence: 'Grid',
                    powered: 'On',
                    trip: 'Compass',
                  },
                  fallback: 'Clock',
                },
                color: {
                  op: 'switch',
                  expr: {
                    op: 'context',
                    path: 'thingActivity.activityType',
                  },
                  options: {
                    geofence: 'success',
                    powered: 'secondary',
                  },
                  fallback: 'primary',
                },
              },
              {
                op: 'translate',
                translation: {
                  op: 'string-replace',
                  find: '{ACTIVITY_TYPE}',
                  replace: {
                    op: 'context',
                    path: 'thingActivity.activityType',
                  },
                  value: 'track:activity-descriptions.{ACTIVITY_TYPE}.label',
                },
              }],
          },
        }, {
          op: 'if',
          condition: {
            op: 'eq',
            a: {
              op: 'context',
              path: 'thingActivity.activityType',
            },
            b: 'geofence',
          },
          then: {
            op: 'ui',
            name: 'Typography',
            variant: 'caption',
            color: {
              op: 'theme-property',
              path: 'palette.text.secondary',
            },
            children: {
              op: 'ui',
              name: 'FetchOne',
              dataType: 'geofence',
              id: {
                op: 'context',
                path: 'accumulator.geofence.geofenceId',
              },
            },
          },
          else: {
            op: 'if',
            condition: {
              op: 'context',
              path: 'thingPerson.personId',
            },
            then: {
              op: 'ui',
              name: 'Typography',
              variant: 'caption',
              color: {
                op: 'theme-property',
                path: 'palette.text.secondary',
              },
              children: {
                op: 'ui',
                name: 'FetchOne',
                dataType: 'person',
                id: {
                  op: 'context',
                  path: 'thingPerson.personId',
                },
              },
            },
          },
        }],
    }, {
      op: 'ui',
      name: 'Stack',
      direction: 'row',
      gap: 1,
      alignItems: 'center',
      children: [
        {
          op: 'ui',
          name: 'Stack',
          children: [
            {
              op: 'ui',
              name: 'Box',
              textAlign: 'right',
              children: [
                {
                  op: 'if',
                  condition: {
                    op: 'context',
                    path: 'thingActivity.start',
                  },
                  then: {
                    op: 'ui',
                    name: 'Tooltip',
                    title: {
                      op: 'format-timestamp',
                      format: 'mediumWithSeconds',
                      value: {
                        op: 'context',
                        path: 'thingActivity.start',
                      },
                    },
                    children: {
                      op: 'ui',
                      name: 'Typography',
                      component: 'span',
                      color: {
                        op: 'theme-property',
                        path: 'palette.text.secondary',
                      },
                      variant: 'caption',
                      children: {
                        op: 'ui',
                        name: 'FormatTimestamp',
                        format: 'timeWithSeconds',
                        value: {
                          op: 'context',
                          path: 'thingActivity.start',
                        },
                      },
                    },

                  },
                },
                {
                  op: 'if',
                  condition: {
                    op: 'context',
                    path: 'thingActivity.finish',
                  },
                  then: {
                    op: 'ui',
                    name: 'Typography',
                    component: 'span',
                    variant: 'caption',
                    color: {
                      op: 'theme-property',
                      path: 'palette.text.secondary',
                    },
                    children: {
                      op: 'ui',
                      name: 'Tooltip',
                      title: {
                        op: 'format-timestamp',
                        format: 'mediumWithSeconds',
                        value: {
                          op: 'context',
                          path: 'thingActivity.finish',
                        },
                      },
                      children: [' - ', {
                        op: 'ui',
                        name: 'FormatTimestamp',
                        format: 'timeWithSeconds',
                        value: {
                          op: 'context',
                          path: 'thingActivity.finish',
                        },
                      }],
                    },
                  },
                },
              ],
            },
            {
              op: 'ui',
              name: 'Breadcrumbs',
              className: 'journey-breadcrumbs',
              separator: '|',
              children: [
                {
                  op: 'if',
                  condition: {
                    op: 'and',
                    values: [
                      {
                        op: 'context',
                        path: 'thingActivity.start',
                      }, {
                        op: 'context',
                        path: 'thingActivity.finish',
                      }],
                  },
                  then: {
                    op: 'ui',
                    name: 'Typography',
                    variant: 'caption',
                    children: {
                      op: 'format-date-period',
                      start: {
                        op: 'context',
                        path: 'thingActivity.start',
                      },
                      end: {
                        op: 'context',
                        path: 'thingActivity.finish',
                      },
                    },
                  },
                },
                {
                  op: 'if',
                  condition: {
                    op: 'eq',
                    a: {
                      op: 'context',
                      path: 'thingActivity.activityType',
                    },
                    b: 'trip',
                  },
                  then: {
                    op: 'ui',
                    name: 'Typography',
                    variant: 'caption',
                    children: {
                      op: 'if',
                      condition: {
                        op: 'context',
                        path: 'accumulator.summary.increase',
                      },
                      then: {
                        op: 'format-distance',
                        display: 'short',
                        meters: {
                          op: 'context',
                          path: 'accumulator.summary.increase',
                        },
                      },
                      else: '0 km',
                    },
                  },
                },
                {
                  op: 'if',
                  condition: {
                    op: 'eq',
                    a: {
                      op: 'context',
                      path: 'thingActivity.activityType',
                    },
                    b: 'trip',
                  },
                  then: {
                    op: 'ui',
                    name: 'Typography',
                    variant: 'caption',
                    children: [
                      {
                        op: 'translate',
                        translation: 'track:activity-descriptions.end-odo.label',
                      },
                      ': ',
                      {
                        op: 'if',
                        condition: {
                          op: 'context',
                          path: 'accumulator.update.value',
                        },
                        then: {
                          op: 'format-distance',
                          display: 'short',
                          unit: 'kilometer',
                          meters: {
                            op: 'context',
                            path: 'accumulator.update.value',
                          },
                        },
                        else: {
                          op: 'ui',
                          name: 'Typography',
                          variant: 'caption',
                          children: 'Unavailable',
                        },
                      },
                    ],
                  },
                },
                {
                  op: 'if',
                  condition: {
                    op: 'eq',
                    a: {
                      op: 'context',
                      path: 'thingActivity.activityType',
                    },
                    b: 'geofence',
                  },
                  then: {
                    op: 'ui',
                    name: 'Typography',
                    variant: 'caption',
                    children: [{
                      op: 'array-length',
                      value: {
                        op: 'context',
                        path: 'events',
                      },
                    }, ' ', {
                      op: 'translate',
                      translation: 'common:terms.event_other',
                    }],
                  },
                },
                {
                  op: 'if',
                  condition: {
                    op: 'eq',
                    a: {
                      op: 'context',
                      path: 'thingActivity.finish',
                    },
                    b: null,
                  },
                  then: {
                    op: 'ui',
                    name: 'Typography',
                    variant: 'caption',
                    children: {
                      op: 'translate',
                      translation: 'track:page.history.ongoing.labels',
                    },
                  },
                }],
            },
          ],
        }, {
          op: 'if',
          condition: {
            op: 'if-role-function',
            role: 'media-viewer',
          },
          then: {
            op: 'ui',
            name: 'Box',
            children: {
              op: 'ui',
              name: 'IconButton',
              size: 'small',
              onClick: {
                op: 'context',
                path: 'handleMenuOpen',
              },
              children: {
                op: 'ui',
                name: 'Icon',
                icon: 'DotMenuHorizontal',
              },
            },

          },
        }],

    }],
  },
  menu: {
    op: 'ui',
    name: 'Menu',
    anchorEl: {
      op: 'context',
      path: 'menuElement',
    },
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'top',
    },
    onClose: {
      op: 'context',
      path: 'handleMenuClose',
    },
    open: {
      op: 'context',
      path: 'menuOpened',
    },
    children: {
      op: 'ui',
      name: 'MenuList',
      children: {
        op: 'ui',
        name: 'MenuItem',
        onClick: {
          op: 'route-function',
          route: {
            op: 'string-replace',
            find: '{THING_ID}',
            replace: {
              op: 'context',
              path: 'thingActivity.thingId',
            },
            value: '/camera/{THING_ID}',
          },
          startTime: {
            op: 'context',
            path: 'thingActivity.start',
          },
          endTime: {
            op: 'if',
            condition: {
              op: 'context',
              path: 'thingActivity.finish',
            },
            then: {
              op: 'context',
              path: 'thingActivity.finish',
            },
            else: {
              op: 'context',
              path: 'timelineEndTime',
            },
          },
        },
        children: [{
          op: 'ui',
          name: 'ListItemIcon',
          children: {
            op: 'ui',
            name: 'Icon',
            icon: 'Camera',
            fontSize: '1.25rem',
          },
        }, {
          op: 'ui',
          name: 'ListItemText',
          children: {
            op: 'translate',
            translation: 'common:component.media-data.action.view-camera-content',
          },
        }],
      },
    },
  },
  content: [
    {
      op: 'ui',
      name: 'Box',
      pt: 1,
      children: {
        op: 'ui',
        name: 'ActivityCardTimeline',
        activity: {
          op: 'context',
          path: 'thingActivity',
        },
        events: {
          op: 'context',
          path: 'events',
        },
      },
    },
  ],
};
